import { Theme } from '@mui/material/styles';

const flexShare = {
  display: 'flex',
  flex: 1,
};

export const containerSx = {
  display: 'flex',
  m: 2.5,
  flexDirection: 'column',
};

export const headerContainerSx = {
  ...flexShare,
  mb: 1,
  flexDirection: 'row',
};

export const titleContaineSx = {
  ...flexShare,
  flexDirection: 'column',
};

export const lineSx = {
  display: 'flex',
  flexDirection: 'row',
  mb: 1.5,
};

export const getColor = (color: 'warning' | 'error', channel: 'light' | 'main') => (theme: Theme) => ({
  color: theme.palette[color]?.[channel]
});

export const statLineSx = (color: 'warning' | 'error') => (theme: Theme) => ({
  ...lineSx,
  ...getColor(color, 'light')(theme),
});

export const statLineTextSx = {
  ...flexShare,
  ml: 1,
};

